import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MaskedInput from "react-text-mask";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import clsx from "clsx"
import { PageLink, PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import RelatorioRelatorio from "./RelatorioRelatorio";
import RelatorioECD from "./RelatorioECD";
import RelatorioResumo from "./RelatorioResumo";
import { IEmpresas } from "../../interfaces/IEmpresas";
import EmpresasService from "../../services/EmpresasService";
import { IEsteira } from "../../interfaces/IRelatorioCliente";
import { pegarEsteiraSelecionada } from "./RelatorioSelecionarCliente";
import RelatoriosService from "../../services/RelatoriosService";
import { MASCARA_DATA } from "../../utils/Constants";
import Swal from "sweetalert2";
import { Console } from "console";
import RelatorioStatus from "./RelatorioStatus";

export enum Tipo {
    Esteira = 'Esteira',
    Erro = 'Erro',
    Aviso = 'Aviso',
    Pendente = 'Pendente',
    Match = 'Match',
    Conciliado = 'Conciliado',
    Recomendacao = 'Recomendacao',
    Relatorio = 'Relatorio',
    Empresa = 'Empresa',
    DataInicial = 'DataInicial',
    DataFinal = 'DataFinal',
    AbaSelecionada = 'AbaSelecionada',
    ContaEmpresa = 'ContaEmpresa',
    ListaContasEmpresa = 'ListaContasEmpresa'
};

export function pegarEmpresaSelecionada(): IEmpresas | undefined {
    const json = localStorage.getItem(`${Tipo.Empresa}`) ?? "";
    const empresa = (json ? JSON.parse(json) : {})  as IEmpresas;
    
    return empresa;

}

export function dataValida(texto: string): { day: number, month: number, year: number } | undefined {

    let partes: string[] = [];
    let day: number;
    let month: number;
    let year: number;

    //Comentario Teste Rafael
    //formato YYYY/MM/dd
    if (/^\d{4}\/\d{2}\/\d{2}$/.test(texto)) {
        partes = texto.split("/");
        day = parseInt(partes[2], 10);
        month = parseInt(partes[1], 10);
        year = parseInt(partes[0], 10);
    }
    //formato YYYY-MM-dd
    else if (/^\d{4}-\d{2}-\d{2}$/.test(texto)) {
        partes = texto.split("-");
        day = parseInt(partes[2], 10);
        month = parseInt(partes[1], 10);
        year = parseInt(partes[0], 10);
    }
    //formato dd/MM/YYYY
    else if (/^\d{2}\/\d{2}\/\d{4}$/.test(texto)) {
        partes = texto.split("/");
        day = parseInt(partes[0], 10);
        month = parseInt(partes[1], 10);
        year = parseInt(partes[2], 10);
    }
    //formato dd-MM-YYYY
    else if (/^\d{2}-\d{2}-\d{4}$/.test(texto)) {
        partes = texto.split("-");
        day = parseInt(partes[0], 10);
        month = parseInt(partes[1], 10);
        year = parseInt(partes[2], 10);
    }
    else {
        return undefined;
    }

    if (year < 1000 || year > 3000 || month === 0 || month > 12) {
        return undefined;
    }

    let monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
        monthLength[1] = 29;
    }

    if (day > 0 && day <= monthLength[month - 1]) {
        return { day, month, year };
    }
}

export const Formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
    //minimumFractionDigits: 0
    //maximumFractionDigits: 0
});

export function limitarTexto(texto: string | undefined, quantidadeCaracteres: number, quantidadeCaracteresManterFinal?: number): string {
    if (texto && texto.length > quantidadeCaracteres) {
        const reticencias = '...';
        const quantidadeCaracteresManterFinalTratado = quantidadeCaracteresManterFinal ?? 0;
        const condicaoPedacoFinal = quantidadeCaracteresManterFinalTratado > 0;
        const quantidadeCaracteresManter = condicaoPedacoFinal ? quantidadeCaracteresManterFinalTratado + reticencias.length : reticencias.length;
        const textoTemp = texto.slice(0, quantidadeCaracteres + quantidadeCaracteresManter).trimEnd();
        const pedacoFinal = texto.slice(texto.length - quantidadeCaracteresManterFinalTratado, texto.length).trimEnd();
        const pedacoFinalTratado = condicaoPedacoFinal ? pedacoFinal : '';
        const textoTempConcatenado = textoTemp + reticencias + pedacoFinalTratado;

        return textoTempConcatenado;
    }

    return texto ?? "";
}

export function Periodo({ dataInicio, dataFim, botoesVisivel, empresaId, filtroVisivel, acaoBotaoBuscar, dadosExportar, imprimirRelatorioExcel }: { dataInicio: Date | undefined, dataFim: Date | undefined, botoesVisivel?: boolean, empresaId?: number, filtroVisivel?: boolean, acaoBotaoBuscar?: (dataInicial: Date | undefined, dataFinal: Date | undefined) => void, dadosExportar: any, imprimirRelatorioExcel?: () => void }) {

    const [dataInicialEntradaFocada, setDataInicialEntradaFocada] = useState<boolean>(false);
    const [dataFinalEntradaFocada, setDataFinalEntradaFocada] = useState<boolean>(false);
    const [dataInicial, setDataInicial] = useState<Date>();
    const [dataFinal, setDataFinal] = useState<Date>();
    const [dataInicialTexto, setDataInicialTexto] = useState<string>('');
    const [dataFinalTexto, setDataFinalTexto] = useState<string>('');
    const [carregandoImprimir, setCarregandoImprimir] = useState<boolean>(false);
    const [carregandoExportar, setCarregandoExportar] = useState<boolean>(false);
    const [mostrarOpcoes, setMostrarOpcoes] = useState<boolean>(false);

    useEffect(() => {
        setDataInicial(dataInicio);
        definirDataTexto(dataInicio, true);

        // eslint-disable-next-line
    }, [dataInicio])

    useEffect(() => {
        setDataFinal(dataFim);
        definirDataTexto(dataFim, false);

        // eslint-disable-next-line
    }, [dataFim])

    useEffect(() => {
        const data = dataValida(dataInicialTexto);

        setDataInicial(data ? new Date(`${data.year}-${data.month}-${data.day}`) : undefined);

        // eslint-disable-next-line
    }, [dataInicialTexto])

    useEffect(() => {
        const data = dataValida(dataFinalTexto);

        setDataFinal(data ? new Date(`${data.year}-${data.month}-${data.day}`) : undefined);

        // eslint-disable-next-line
    }, [dataFinalTexto])

    async function imprimir () {
        if (empresaId && dataInicial && dataFinal) {
            const json = localStorage.getItem(`${Tipo.ListaContasEmpresa}`) ?? "";
            const listaContasEmpresa = json ? JSON.parse(json) as string[] : [];

            if (listaContasEmpresa.length > 0) {
                setCarregandoImprimir(true);
                await RelatoriosService.pegarUrlImpressao(empresaId, listaContasEmpresa, dataInicial, dataFinal, x => x.forEach((p, key) =>  {
                    var printWindow = window.open('', 'Relatório ' + key);
                    printWindow?.document.write(p);
                    printWindow?.document.close();
                    printWindow?.print();
                }));
                setCarregandoImprimir(false);
            } else {
                await Swal.fire({
                    text: 'Selecione pelo menos um item para imprimir!',
                    icon: 'info',
                    showConfirmButton: true
                })
            }
        }
    }

    async function exportarTodos () {
        if (empresaId && dataInicial && dataFinal) {
            setCarregandoExportar(true);
            await RelatoriosService.exportarTodosExcel(empresaId, dataInicial, dataFinal, () => {}, 'Relatório encaminhado para geração, verifique seu e-mail dentro de 15 minutos!');
            setCarregandoExportar(false);
        }
    }

    function definirDataTexto(valor: any, dataInicial: boolean) {
        let data: Date;

        if (valor as string) {
            data = new Date(valor);
        }
        else if (valor as Date) {
            data = valor;
        }
        else {
            return;
        }

        if (data) {
            const pedacos = data.toISOString().substring(0, 10).split('-');
            const dia = pedacos[2].padStart(2, "0");
            const mes = pedacos[1].padStart(2, "0");
            const ano = pedacos[0].padStart(4, "0");

            dataInicial ? setDataInicialTexto(`${dia}/${mes}/${ano}`) : setDataFinalTexto(`${dia}/${mes}/${ano}`);
        }
        else {
            dataInicial ? setDataInicialTexto('') : setDataFinalTexto('');
        }
    }

    return (
        <div style={{ display: 'flex', marginTop: '10px', alignItems: 'center', width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center', visibility: filtroVisivel === undefined || filtroVisivel ? 'visible' : 'hidden' }}>
                <label style={{ margin: '0 10px' }}>Período</label>
                <div style={{ border: '1px solid', borderColor: dataInicialEntradaFocada ? '#444' : '#ccc', borderRadius: '5px', padding: '5px 0', width: '110px', overflow: 'hidden' }}>
                    <input type="date" style={{ width: '45px', marginLeft: '-30px', border: 'none', outline: 'none' }} onFocus={() => setDataInicialEntradaFocada(true)} onBlur={() => setDataInicialEntradaFocada(false)} onChange={e => definirDataTexto(e.target.value, true)} />
                    <MaskedInput mask={MASCARA_DATA} tabIndex={1} type="text" style={{ border: 'none', outline: 'none', width: '85px' }} placeholder="dd/MM/YYYY" value={dataInicialTexto} onChange={e => setDataInicialTexto(e.target.value)} onFocus={() => setDataInicialEntradaFocada(true)} onBlur={() => setDataInicialEntradaFocada(false)} />
                </div>
                <label style={{ margin: '0 10px' }}>à</label>
                <div style={{ border: '1px solid', borderColor: dataFinalEntradaFocada ? '#444' : '#ccc', borderRadius: '5px', padding: '5px 0', width: '110px', overflow: 'hidden' }}>
                    <input type="date" style={{ width: '45px', marginLeft: '-30px', border: 'none', outline: 'none' }} onFocus={() => setDataFinalEntradaFocada(true)} onBlur={() => setDataFinalEntradaFocada(false)} onChange={e => definirDataTexto(e.target.value, false)} />
                    <MaskedInput mask={MASCARA_DATA} tabIndex={2} type="text" style={{ border: 'none', outline: 'none', width: '85px' }} placeholder="dd/MM/YYYY" value={dataFinalTexto} onChange={e => setDataFinalTexto(e.target.value)} onFocus={() => setDataFinalEntradaFocada(true)} onBlur={() => setDataFinalEntradaFocada(false)} />
                </div>
                <button id="botao" tabIndex={3} className='btn btn-sm btn-primario' disabled={!(dataInicial && dataFinal)} style={{ visibility: (filtroVisivel === undefined || filtroVisivel) && acaoBotaoBuscar ? 'visible' : 'hidden', marginLeft: '5px', padding: '7px 12px' }} onClick={() => acaoBotaoBuscar && acaoBotaoBuscar(dataInicial, dataFinal)} >
                    <i className="icon-lg text-white bi bi-search" />
                </button>
            </div>
            <div style={{ position: 'relative', marginLeft: '5px', visibility: botoesVisivel === null || botoesVisivel === undefined || botoesVisivel ? 'visible' : 'hidden' }}>
                <button onClick={() => setMostrarOpcoes(!mostrarOpcoes)} className='btn btn-sm btn-primario' style={{ marginRight: '5px' }}>
                    <span style={{ verticalAlign: 'middle' }}> OPÇÕES </span>
                </button>
                {mostrarOpcoes && (
                    <div style={{ width: '100px', display: 'flex', position: 'absolute', top: '54px', right: '81px' }}>
                        <button onClick={() => {
                            if (imprimirRelatorioExcel) {
                                    imprimirRelatorioExcel()
                                } else {
                                    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                                    const fileExtension = ".xlsx";
                                    const ws = XLSX.utils.json_to_sheet(dadosExportar);
                                    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                                    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                                    const data = new Blob([excelBuffer], { type: fileType });
                                    saveAs(data, `Relatorio-${Date.now()}` + fileExtension);
                                }
                            }} className='btn btn-sm btn-primario'>
                            <i className="icon-lg text-white fas fa-file-medical" />
                            <span style={{ verticalAlign: 'middle' }}> EXPORTAR </span>
                        </button>
                        <button style={{ marginLeft: '5px' }} disabled={!(empresaId && dataInicial && dataFinal) || carregandoImprimir} className='btn btn-sm btn-primario' onClick={async () => imprimir()}>
                            {
                                carregandoImprimir ?
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        <span className='spinner-border spinner-border-sm' style={{ marginRight: '5px' }} />
                                        Carregando
                                    </span>
                                    :
                                    <>
                                        <i className="icon-lg text-white fas fa-print" />
                                        <span style={{ verticalAlign: 'middle' }}>
                                            IMPRIMIR
                                        </span>
                                    </>
                            }
                        </button>
                        <button style={{ marginLeft: '5px' }} disabled={!(empresaId && dataInicial && dataFinal) || carregandoExportar} className='btn btn-sm btn-primario' onClick={async () => exportarTodos()}>
                            {
                                carregandoExportar ?
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        <span className='spinner-border spinner-border-sm' style={{ marginRight: '5px' }} />
                                        Carregando
                                    </span>
                                    :
                                    <>
                                        <i className="icon-lg text-white fas fa-print" />
                                        <span style={{ verticalAlign: 'middle' }}>
                                            EXPORTAR TODOS
                                        </span>
                                    </>
                            }
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

function Relatorio() {
    const { classes } = useLayout();
    const { id } = useParams<{ id: string }>();
    const [dataInicial, setDataInicial] = useState<Date>();
    const [dataFinal, setDataFinal] = useState<Date>();
    const [abaSelecionada, setAbaSelecionada] = useState<number>(1);
    const [esteiraSelecionada, setEsteiraSelecionada] = useState<IEsteira>();
    const [empresaSelecionada, setEmpresaSelecionada] = useState<IEmpresas>();
    const [dadosExportar, setDadosExportar] = useState<any>();

    const opcoesFiltros = [
        { id: 1, descricao: 'Status', habilitado: true },
        { id: 2, descricao: 'Resumo', habilitado: true },
        { id: 3, descricao: 'Relatório', habilitado: true },
        { id: 4, descricao: 'ECDs', habilitado: true },
        { id: 5, descricao: 'Notas Fiscais', habilitado: false },
        { id: 6, descricao: 'Estornos', habilitado: false }
    ];
    const breadCrumbs: Array<PageLink> = [
        {
            title: 'Clientes',
            path: '/relatorioSelecionarCliente',
            isSeparator: false,
            isActive: false
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: true
        }
    ]

    useEffect(() => {
        function preCarregar() {
            try {
                const titulo = document.querySelectorAll("h1")[0];
                const estilo = titulo.getAttribute('style') + 'font-size: 14px';

                titulo.setAttribute('style', estilo);
            } catch {
                setTimeout(() => {
                    preCarregar();
                }, 50);
            }
        }

        const jsonDataInicial = localStorage.getItem(`${Tipo.DataInicial}`) as "";
        const dataInicial = JSON.parse(jsonDataInicial) as Date | undefined;
        const jsonDataFinal = localStorage.getItem(`${Tipo.DataFinal}`) as "";
        const dataFinal = JSON.parse(jsonDataFinal) as Date | undefined;
        const jsonAbaSelecionada = localStorage.getItem(`${Tipo.AbaSelecionada}`) as "";
        const abaSelecionada = JSON.parse(jsonAbaSelecionada) as number ?? 1;

        setDataInicial(dataInicial);
        setDataFinal(dataFinal);
        setAbaSelecionada(abaSelecionada);

        localStorage.setItem(`${Tipo.AbaSelecionada}`, JSON.stringify(null));

        preCarregar();
    }, [])

    useEffect(() => {
        localStorage.setItem(`${Tipo.Empresa}`, JSON.stringify(empresaSelecionada));
    }, [empresaSelecionada])

    useEffect(() => {
        localStorage.setItem(`${Tipo.DataInicial}`, JSON.stringify(dataInicial));
    }, [dataInicial])

    useEffect(() => {
        localStorage.setItem(`${Tipo.DataFinal}`, JSON.stringify(dataFinal));
    }, [dataFinal])

    useEffect(() => {
        localStorage.setItem(`${Tipo.ContaEmpresa}`, JSON.stringify(null));
    }, [abaSelecionada])

    useEffect(() => {
        async function preCarregar() {
            try {
                const empresa = await EmpresasService.obterPorId(parseInt(id));

                setEmpresaSelecionada(empresa);
            } catch (error: any) {
                console.log(error);
            }
        }

        const esteira = pegarEsteiraSelecionada();

        setEsteiraSelecionada(esteira);

        setTimeout(() => {
            preCarregar();
        }, 1000)
    }, [id])

    function BotoesHeaderTabela() {
        return <>
            {
                opcoesFiltros.map((x, index) => <button key={index} type="submit" id={`item-${index}`} className={`btn btn-filtro ${x.id === abaSelecionada && x.habilitado && 'ativo'}`} disabled={!x.habilitado} onClick={() => x.habilitado && setAbaSelecionada(x.id)}>{x.descricao}</button>)
            }
        </>
    };

    function trocarAba(abaSelecionada: number) {
        switch (abaSelecionada) {
            case 1:
                return <RelatorioStatus empresa={empresaSelecionada} />
            case 2:
                return <RelatorioResumo empresa={empresaSelecionada} dataInicial={dataInicial} dataFinal={dataFinal} />
            case 3:
                return <RelatorioRelatorio setDadosExportar={setDadosExportar} empresa={empresaSelecionada} dataInicial={dataInicial} dataFinal={dataFinal} />
            case 4:
                return <RelatorioECD empresa={empresaSelecionada} dataInicial={dataInicial} dataFinal={dataFinal} esteira={esteiraSelecionada} />
        }
    };

    function acaoBotaoPeriodo(dataInicial: Date | undefined, dataFinal: Date | undefined) {
        setDataInicial(dataInicial);
        setDataFinal(dataFinal);
    }

    return <>
        <PageTitle pageBack="/relatorioSelecionarCliente" breadcrumbs={breadCrumbs}>{localStorage.getItem(`${Tipo.Relatorio}`)}</PageTitle>
        <div className='toolbar' id='kt_toolbar' style={{ paddingRight: '10px' }}>
            <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex')} style={{ paddingRight: '10px' }}>
                <DefaultTitle />
                <Periodo dadosExportar={dadosExportar} dataInicio={dataInicial} dataFim={dataFinal} botoesVisivel={abaSelecionada === 3} acaoBotaoBuscar={acaoBotaoPeriodo} empresaId={parseInt(id)} />
            </div>
        </div>

        <BotoesHeaderTabela />
        {
            trocarAba(abaSelecionada)
        }
    </>
};

export default Relatorio;